import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var __privateMethod = function __privateMethod(obj, member, method) {
  __accessCheck(obj, member, "access private method");

  return method;
};

var _mediaController, _button, _buttonSlot, _listbox, _listboxSlot, _keyupListener, _keydownListener, _documentClickHandler, _clickHandler, _handleOptionChange, _toggle, toggle_fn, _show, show_fn, _hide, hide_fn, _updateMenuPosition;

import "../media-chrome-button.js";
import "./media-chrome-listbox.js";
import { globalThis, document } from "../utils/server-safe-globals.js";
import { containsComposedNode, closestComposedNode, getOrInsertCSSRule, getActiveElement } from "../utils/element-utils.js";
import { observeResize, unobserveResize } from "../utils/resize-observer.js";
import { MediaStateReceiverAttributes } from "../constants.js";
var template = document.createElement("template");
template.innerHTML = "\n  <style>\n  :host {\n    font: var(--media-font,\n      var(--media-font-weight, normal)\n      var(--media-font-size, 15px) /\n      var(--media-text-content-height, var(--media-control-height, 24px))\n      var(--media-font-family, helvetica neue, segoe ui, roboto, arial, sans-serif));\n    color: var(--media-text-color, var(--media-primary-color, rgb(238 238 238)));\n    display: inline-flex;\n    position: relative;\n    flex-shrink: .5;\n  }\n\n  [name=listbox]::slotted(*),\n  [part=listbox] {\n    position: absolute;\n    bottom: 100%;\n    max-height: 300px;\n    transition: var(--media-selectmenu-transition-in,\n      visibility 0s, transform .15s ease-out, opacity .15s ease-out);\n    transform: var(--media-listbox-transform-in, translateY(0) scale(1));\n    visibility: visible;\n    opacity: 1;\n  }\n\n  [name=listbox][hidden]::slotted(*),\n  [hidden] [part=listbox] {\n    transition: var(--media-selectmenu-transition-out,\n      visibility .15s ease-out, transform .15s ease-out, opacity .15s ease-out);\n    transform: var(--media-listbox-transform-out, translateY(2px) scale(.99));\n    visibility: hidden;\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  slot[name=listbox][hidden] {\n    display: block;\n  }\n  </style>\n\n  <slot name=\"button\">\n    <media-chrome-button aria-haspopup=\"listbox\" part=\"button\">\n      <slot name=\"button-content\"></slot>\n    </media-chrome-button>\n  </slot>\n  <slot name=\"listbox\" hidden>\n    <media-chrome-listbox id=\"listbox\" part=\"listbox\">\n      <slot></slot>\n    </media-chrome-listbox>\n  </slot>\n";

var MediaChromeSelectMenu = /*#__PURE__*/function (_globalThis$HTMLEleme) {
  _inherits(MediaChromeSelectMenu, _globalThis$HTMLEleme);

  var _super = _createSuper(MediaChromeSelectMenu);

  function MediaChromeSelectMenu() {
    var _this;

    _classCallCheck(this, MediaChromeSelectMenu);

    var _a;

    _this = _super.call(this);

    __privateAdd(_assertThisInitialized(_this), _toggle);

    __privateAdd(_assertThisInitialized(_this), _show);

    __privateAdd(_assertThisInitialized(_this), _hide);

    __privateAdd(_assertThisInitialized(_this), _mediaController, void 0);

    __privateAdd(_assertThisInitialized(_this), _button, void 0);

    __privateAdd(_assertThisInitialized(_this), _buttonSlot, void 0);

    __privateAdd(_assertThisInitialized(_this), _listbox, void 0);

    __privateAdd(_assertThisInitialized(_this), _listboxSlot, void 0);

    __privateAdd(_assertThisInitialized(_this), _keyupListener, function (e) {
      var key = e.key;

      if (!_this.keysUsed.includes(key)) {
        _this.removeEventListener("keyup", __privateGet(_assertThisInitialized(_this), _keyupListener));

        return;
      }

      var isButton = e.composedPath().includes(__privateGet(_assertThisInitialized(_this), _button));

      if (isButton && (key === "Enter" || key === " ")) {
        __privateMethod(_assertThisInitialized(_this), _toggle, toggle_fn).call(_assertThisInitialized(_this));
      } else if (key === "Escape") {
        __privateMethod(_assertThisInitialized(_this), _hide, hide_fn).call(_assertThisInitialized(_this));
      }
    });

    __privateAdd(_assertThisInitialized(_this), _keydownListener, function (e) {
      var metaKey = e.metaKey,
          altKey = e.altKey,
          key = e.key;

      if (metaKey || altKey || !_this.keysUsed.includes(key)) {
        _this.removeEventListener("keyup", __privateGet(_assertThisInitialized(_this), _keyupListener));

        return;
      }

      e.preventDefault();

      _this.addEventListener("keyup", __privateGet(_assertThisInitialized(_this), _keyupListener), {
        once: true
      });
    });

    __privateAdd(_assertThisInitialized(_this), _documentClickHandler, function (e) {
      if (e.composedPath().includes(_assertThisInitialized(_this))) return;

      __privateMethod(_assertThisInitialized(_this), _hide, hide_fn).call(_assertThisInitialized(_this));
    });

    __privateAdd(_assertThisInitialized(_this), _clickHandler, function (e) {
      if (e.composedPath().includes(__privateGet(_assertThisInitialized(_this), _button))) {
        __privateMethod(_assertThisInitialized(_this), _toggle, toggle_fn).call(_assertThisInitialized(_this));
      }
    });

    __privateAdd(_assertThisInitialized(_this), _handleOptionChange, function () {
      __privateMethod(_assertThisInitialized(_this), _hide, hide_fn).call(_assertThisInitialized(_this));
    });

    __privateAdd(_assertThisInitialized(_this), _updateMenuPosition, function () {
      if (__privateGet(_assertThisInitialized(_this), _listbox).offsetWidth === 0) return;

      var listboxWidth = __privateGet(_assertThisInitialized(_this), _listbox).offsetWidth;

      var buttonRect = __privateGet(_assertThisInitialized(_this), _button).getBoundingClientRect();

      if (_this.hasAttribute("mediacontroller") || __privateGet(_assertThisInitialized(_this), _button).hasAttribute("mediacontroller") || __privateGet(_assertThisInitialized(_this), _listbox).hasAttribute("mediacontroller")) {
        __privateGet(_assertThisInitialized(_this), _listbox).style.zIndex = "1";
        __privateGet(_assertThisInitialized(_this), _listbox).style.bottom = "unset";
        __privateGet(_assertThisInitialized(_this), _listbox).style.right = null;
        __privateGet(_assertThisInitialized(_this), _listbox).style.left = "0";
        __privateGet(_assertThisInitialized(_this), _listbox).style.top = "".concat(buttonRect.height, "px");
        return;
      }

      var bounds = getBoundsElement(_assertThisInitialized(_this));
      var boundsRect = bounds.getBoundingClientRect();
      var listboxRight = buttonRect.x + listboxWidth;
      var position = Math.max(buttonRect.right - listboxRight, buttonRect.right - boundsRect.right);
      __privateGet(_assertThisInitialized(_this), _listbox).style.left = null;
      __privateGet(_assertThisInitialized(_this), _listbox).style.right = "".concat(position, "px");
      __privateGet(_assertThisInitialized(_this), _listbox).style.maxHeight = "".concat(boundsRect.height - buttonRect.height, "px");
    });

    if (!_this.shadowRoot) {
      _this.attachShadow({
        mode: "open"
      });

      _this.shadowRoot.appendChild(template.content.cloneNode(true));
    }

    var _getOrInsertCSSRule = getOrInsertCSSRule(_this.shadowRoot, ":host"),
        style = _getOrInsertCSSRule.style;

    style.setProperty("display", "var(--media-control-display, var(--".concat(_this.localName, "-display, inline-flex))"));
    (_a = _this.init) == null ? void 0 : _a.call(_assertThisInitialized(_this));

    __privateSet(_assertThisInitialized(_this), _button, _this.shadowRoot.querySelector("[part=button]"));

    __privateSet(_assertThisInitialized(_this), _listbox, _this.shadowRoot.querySelector("[part=listbox]"));

    __privateSet(_assertThisInitialized(_this), _buttonSlot, _this.shadowRoot.querySelector("slot[name=button]"));

    __privateGet(_assertThisInitialized(_this), _buttonSlot).addEventListener("slotchange", function () {
      var newButton = __privateGet(_assertThisInitialized(_this), _buttonSlot).assignedElements()[0];

      if (!newButton) return;

      __privateSet(_assertThisInitialized(_this), _button, newButton);

      __privateGet(_assertThisInitialized(_this), _button).preventClick = true;

      var disabled = _this.hasAttribute("disabled") || __privateGet(_assertThisInitialized(_this), _button).hasAttribute("disabled");

      if (disabled) {
        _this.disable();
      } else {
        _this.enable();

        __privateGet(_assertThisInitialized(_this), _button).setAttribute("aria-haspopup", "listbox");
      }
    });

    __privateSet(_assertThisInitialized(_this), _listboxSlot, _this.shadowRoot.querySelector("slot[name=listbox]"));

    __privateGet(_assertThisInitialized(_this), _listboxSlot).addEventListener("slotchange", function () {
      __privateSet(_assertThisInitialized(_this), _listbox, __privateGet(_assertThisInitialized(_this), _listboxSlot).assignedElements()[0] || __privateGet(_assertThisInitialized(_this), _listbox));
    });

    return _this;
  }

  _createClass(MediaChromeSelectMenu, [{
    key: "enable",
    value: function enable() {
      __privateGet(this, _button).toggleAttribute("disabled", false);

      this.addEventListener("change", __privateGet(this, _handleOptionChange));
      this.addEventListener("keydown", __privateGet(this, _keydownListener));
      this.addEventListener("click", __privateGet(this, _clickHandler));
      document.addEventListener("click", __privateGet(this, _documentClickHandler));
    }
  }, {
    key: "disable",
    value: function disable() {
      __privateGet(this, _button).toggleAttribute("disabled", true);

      this.removeEventListener("change", __privateGet(this, _handleOptionChange));
      this.removeEventListener("keydown", __privateGet(this, _keydownListener));
      this.removeEventListener("keyup", __privateGet(this, _keyupListener));
      this.removeEventListener("click", __privateGet(this, _clickHandler));
      document.removeEventListener("click", __privateGet(this, _documentClickHandler));
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      var _a, _b, _c, _d, _e;

      if (attrName === MediaStateReceiverAttributes.MEDIA_CONTROLLER) {
        if (oldValue) {
          (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

          __privateSet(this, _mediaController, null);

          __privateGet(this, _listbox).removeAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER);
        }

        if (newValue && this.isConnected) {
          __privateSet(this, _mediaController, (_c = this.getRootNode()) == null ? void 0 : _c.getElementById(newValue));

          (_e = (_d = __privateGet(this, _mediaController)) == null ? void 0 : _d.associateElement) == null ? void 0 : _e.call(_d, this);

          __privateGet(this, _listbox).setAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER, newValue);
        }
      } else if (attrName === "disabled" && newValue !== oldValue) {
        if (newValue == null) {
          this.enable();
        } else {
          this.disable();
        }
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _a, _b, _c;

      var mediaControllerId = this.getAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER);

      if (mediaControllerId) {
        __privateSet(this, _mediaController, (_a = this.getRootNode()) == null ? void 0 : _a.getElementById(mediaControllerId));

        (_c = (_b = __privateGet(this, _mediaController)) == null ? void 0 : _b.associateElement) == null ? void 0 : _c.call(_b, this);

        __privateGet(this, _listbox).setAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER, mediaControllerId);
      }

      if (!this.hasAttribute("disabled")) {
        this.enable();
      }

      if (!__privateGet(this, _listboxSlot).hidden) {
        observeResize(getBoundsElement(this), __privateGet(this, _updateMenuPosition));
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _a, _b;

      unobserveResize(getBoundsElement(this), __privateGet(this, _updateMenuPosition));
      this.disable();
      (_b = (_a = __privateGet(this, _mediaController)) == null ? void 0 : _a.unassociateElement) == null ? void 0 : _b.call(_a, this);

      __privateSet(this, _mediaController, null);

      __privateGet(this, _listbox).removeAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER);
    }
  }, {
    key: "keysUsed",
    get: function get() {
      return ["Enter", "Escape", " ", "ArrowUp", "ArrowDown", "f", "c", "k", "m"];
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["disabled", MediaStateReceiverAttributes.MEDIA_CONTROLLER];
    }
  }]);

  return MediaChromeSelectMenu;
}(globalThis.HTMLElement);

_mediaController = new WeakMap();
_button = new WeakMap();
_buttonSlot = new WeakMap();
_listbox = new WeakMap();
_listboxSlot = new WeakMap();
_keyupListener = new WeakMap();
_keydownListener = new WeakMap();
_documentClickHandler = new WeakMap();
_clickHandler = new WeakMap();
_handleOptionChange = new WeakMap();
_toggle = new WeakSet();

toggle_fn = function toggle_fn() {
  if (__privateGet(this, _listboxSlot).hidden) {
    __privateMethod(this, _show, show_fn).call(this);
  } else {
    __privateMethod(this, _hide, hide_fn).call(this);
  }
};

_show = new WeakSet();

show_fn = function show_fn() {
  if (!__privateGet(this, _listboxSlot).hidden) return;
  __privateGet(this, _listboxSlot).hidden = false;

  __privateGet(this, _button).setAttribute("aria-expanded", "true");

  __privateGet(this, _updateMenuPosition).call(this);

  __privateGet(this, _listbox).focus();

  observeResize(getBoundsElement(this), __privateGet(this, _updateMenuPosition));
};

_hide = new WeakSet();

hide_fn = function hide_fn() {
  if (__privateGet(this, _listboxSlot).hidden) return;
  unobserveResize(getBoundsElement(this), __privateGet(this, _updateMenuPosition));
  var activeElement = getActiveElement();
  __privateGet(this, _listboxSlot).hidden = true;

  __privateGet(this, _button).setAttribute("aria-expanded", "false");

  if (containsComposedNode(__privateGet(this, _listbox), activeElement)) {
    __privateGet(this, _button).focus();
  }
};

_updateMenuPosition = new WeakMap();

function getBoundsElement(host) {
  var _a;

  return (_a = host.getAttribute("bounds") ? closestComposedNode(host, "#".concat(host.getAttribute("bounds"))) : getMediaControllerElement(host) || host.parentElement) != null ? _a : host;
}

function getMediaControllerElement(host) {
  var _a;

  var mediaControllerId = host.getAttribute(MediaStateReceiverAttributes.MEDIA_CONTROLLER);

  if (mediaControllerId) {
    return (_a = host.getRootNode()) == null ? void 0 : _a.getElementById(mediaControllerId);
  }

  return closestComposedNode(host, "media-controller");
}

if (!globalThis.customElements.get("media-chrome-selectmenu")) {
  globalThis.customElements.define("media-chrome-selectmenu", MediaChromeSelectMenu);
}

var media_chrome_selectmenu_default = MediaChromeSelectMenu;
export { MediaChromeSelectMenu, media_chrome_selectmenu_default as default };